import React from 'react';
import Title from '../../../../../@casino/ui/title';
import TableCasino from '../../../../../@casino/ui/table';
import {useRouter} from '../../../../../@casino/useRouter';
import { useDispatch, useSelector } from 'react-redux';
import { setGetListLottery } from '../../store/thunk/setGetListLottery';

const getDateForm = (event_date) => {
    const day = new Date(+event_date).getDate() < 10 ? '0' + new Date(+event_date).getDate() : new Date(+event_date).getDate();
    const month = +new Date(+event_date).getMonth() + 1 < 10? '0' + (+new Date(+event_date).getMonth() + 1) : new Date(+event_date).getMonth() + 1;
    const year = new Date(+event_date).getFullYear();
    
    return `${day}/${month}/${year}`
}

const LotteryList = () => {
    const router = useRouter();
    const dispatch = useDispatch();
    
    React.useEffect(() => {
        dispatch(setGetListLottery({
            page: 1,
            rowsPerPage: 10
        }));
        
    }, []);

    const list_lottery = useSelector((state) => state.lottery.list);

    const columns = [
        { id: 'id', label: 'ID'},
        { id: 'name', label: 'Название'},
        { id: 'date_from', label: 'Начало'},
        { id: 'date_to', label: 'Конец'},
        { id: 'count_winners', label: 'Кол-во призовых мест'},
        { id: 'fund', label: 'Призовой фонд'},
        { id: 'price_ticket', label: 'Цена билета'},
        { id: 'price_ticket_deposit', label: 'Цена билета от депозита'},
        { id: 'gold_ticket', label: 'Цена золотого билета'},
        { id: 'status', label: 'Статус'}
    ];
  
    const rows = list_lottery.data.map((item) => {
        return {
            id: item.id,
            name: item.label,
            date_from: getDateForm(+item.date_from),
            date_to: getDateForm(+item.date_to),
            count_winners: item.count_winners,
            fund: new Intl.NumberFormat('ru-RU').format(item.fund) + '₽',
            price_ticket: new Intl.NumberFormat('ru-RU').format(item.price_ticket) + '₽',
            price_ticket_deposit: new Intl.NumberFormat('ru-RU').format(item.price_ticket_deposit) + '₽',
            gold_ticket: new Intl.NumberFormat('ru-RU').format(item.gold_ticket) + '₽',
            status: item.status ? 'Активен' : 'Архив'
        }
    })

    return (
        <div style={{padding: 20, paddingTop: 0}}>
            <Title label="Лотерея" />
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
                marginBottom: 12,
                display: 'flex',
                justifyContent: 'flex-end'
            }}>
                <span style={{
                    padding: 10, 
                    background: '#ffc324', 
                    borderRadius: 4, 
                    cursor: 'pointer', 
                    color: '#141b33',
                }}
                    onClick={() => router.history.push('/lottery/create')}
                >Создать лотерею</span>
            </div>
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
            }}>
                <TableCasino
                    pagination
                    allPage={list_lottery.page}
                
                    perPage={10}
                  
                    changePage={(v) => dispatch(setGetListLottery({
                        page: +v.page+1,
                        rowsPerPage: v.rowsPerPage,
            
                    }))}
                    changeRowsPerPage={(v) => dispatch(setGetListLottery({
                        page: +v.page + 1,
                        rowsPerPage: v.rowsPerPage,
                    }))}
                    route="/lottery/edit/"
                    width={1600}
                    columns={columns}
                    rows={rows} 
                />
            </div>
        </div>
    )
}

export default LotteryList;